import { Button, ButtonProps, Flex } from '@chakra-ui/react'
import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { RouteLoaderData } from '@customTypes/index'
import { Route as listRecordingsRoute } from '@routes/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r'
import { RecordingDetail } from '@features/recordings/components/RecordingDetail'

const BackButton = (props: ButtonProps) => {
  const { orgId, projectId, workflowSessionId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId',
  })

  return (
    <Link
      to={listRecordingsRoute.to}
      params={{ orgId, projectId, workflowSessionId }}
    >
      <Button {...props} size={'xs'}>
        Back to recordings
      </Button>
    </Link>
  )
}

const RecordingDetailRoute = () => {
  const { recordingId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId',
  })
  return (
    <Flex direction="column" h="100%" overflow="hidden" px={3}>
      <BackButton />
      <RecordingDetail recordingId={recordingId} />
    </Flex>
  )
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r/$recordingId'
)({
  component: RecordingDetailRoute,
  beforeLoad: () => ({ getTitle: () => 'Clips' }),
  loader: (): RouteLoaderData => ({
    crumb: 'Clips',
    constrainHeight: true,
  }),
})
